import { loyaltyActions } from './models/loyalty';
import { orderActions } from './models/order';
import { orderingActions } from './models/ordering';

export const actions = {
  loyalty: loyaltyActions,
  order: orderActions,
  ordering: orderingActions,
};
